import { useRef } from "react";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import Challenges from "@/components/site/Challenges";
import Solutions from "@/components/site/Solutions";
import Methodology from "@/components/site/Methodology";
import Results from "@/components/site/Results";
import Industries from "@/components/site/Industries";
import Environments from "@/components/site/Environments";
import Testimonials from "@/components/site/Testimonials";
import WhyClinivon from "@/components/site/WhyClinivon";
import ContactForm from "@/components/site/ContactForm";
import FinalCTA from "@/components/site/FinalCTA";
import Footer from "@/components/site/Footer";
import ChatWidget from "@/components/site/ChatWidget";

export default function HomePage() {
  const formRef = useRef(null);
  const scrollToContact = () => {
    document.getElementById("contact")?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <div data-testid="home-page">
      <Navbar />
      <Hero onBook={scrollToContact} onAssessment={scrollToContact} onUpload={scrollToContact} />
      <Challenges />
      <Solutions onContact={scrollToContact} />
      <Methodology />
      <Results />
      <Environments />
      <Industries />
      <Testimonials />
      <WhyClinivon />
      <ContactForm formRef={formRef} />
      <FinalCTA onContact={scrollToContact} />
      <Footer />
      <ChatWidget onOpenForm={scrollToContact} />
    </div>
  );
}
